/**
 * NATS subject naming, in one place.
 *
 * Deliberately dependency-free, and reachable on its own `@web-monorepo/realtime/subjects`
 * subpath: the Playwright harness imports it from Node, where the package barrel's NATS client
 * and React cannot load.
 */

/**
 * The subject a realtime client uses for `topicOrEntityId`.
 *
 * A value that already names a subject (`classroom.${classId}`) is used as-is; a bare id is a
 * user id, and its subject is `user.${id}`. `RealtimeUserClient` derives its topic through this,
 * so a test that wants the subject for a user does not have to re-type the format.
 */
export function userSubject(topicOrEntityId: string): string {
  return topicOrEntityId.includes(".") ? topicOrEntityId : `user.${topicOrEntityId}`;
}
